<template>
  <v-col class="text-center">
    <v-btn
      color="#f6f5f4"
      :to="{ name: chip == 'featured' ? 'menu' : chip }"
      icon
    >
      <div class="align-center d-flex flex-column">
        <div class="pb-1">
          <v-icon
            v-if="chip === 'deals' && $route.name === 'deals'"
            color="primary"
            >mdi-label-percent</v-icon
          >
          <img
            v-if="chip === 'deals' && $route.name !== 'deals'"
            alt="deals navigation icon"
            src="@/assets/mobile/navigation/ic-deals-inactive.svg"
            height="21"
            width="20"
          />
          <Icon
            v-if="chip !== 'deals'"
            :name="'mob_nav_' + chip + ($route.name === chip || ($route.name === 'menu' && chip === 'featured') ? '_active' : '_inactive')"
            :color="$vuetify.theme.themes.light.primary"
            :title="`${chip} navigation icon`"
          ></Icon>
        </div>
        <div :class="renderFontColor()" class="font-size-xxs text-capitalize">
          {{ chip }}
        </div>
      </div>
    </v-btn>
  </v-col>
</template>

<script>
import Icon from '@/components/UI/Icon.vue'
export default {
  name: "NavTile",
  components: {Icon},
  methods: {
    renderFontColor() {
      return this.$route.name === this.chip ||
        (this.$route.name === "menu" && this.chip == "featured")
        ? "primary--text"
        : "color-black-magic";
    },
    renderNavigationIconColor() {
      return this.$route.name === this.chip ? "primary" : "#2a2825";
    },
    renderNavigationIconName() {
      return this.$route.name === this.chip
        ? "mdi-label-percent"
        : "mdi-label-percent-outline";
    },
    renderNavigationImage() {
      return this.$route.name === this.chip ||
        (this.$route.name === "menu" && this.chip == "featured")
        ? require(`@/assets/mobile/navigation/ic-${this.chip}-active.svg`)
        : require(`@/assets/mobile/navigation/ic-${this.chip}-inactive.svg`);
    },
  },
  props: { chip: String },
};
</script>
